export default __webpack_public_path__ + "static/b41-2ac6694a736df2f0c6f8161d66587ebb.png";